module.exports = __webpack_public_path__ + "static/img/Page02_02.7bec105.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Page02_02.jpeg
// module id = Ltbh
// module chunks = 0